import { APPLE_SOCIAL, FACEBOOK_SOCIAL, LINE_SOCIAL } from '../constant/social'
import { UNLOCK, ENVELOPE, CHECK_CIRCLE, WARNING } from '../constant/fa'

const APPLE_SOCIAL_ICON = 'fa-apple'
const FACEBOOK_SOCIAL_ICON = 'fa-facebook'
const LINE_SOCIAL_ICON = 'fa-line'

const SOCIAL_ICON_MAPPING: ConstantMapping = {
  [APPLE_SOCIAL]: APPLE_SOCIAL_ICON,
  [FACEBOOK_SOCIAL]: FACEBOOK_SOCIAL_ICON,
  [LINE_SOCIAL]: LINE_SOCIAL_ICON
}

export function formatSocialIcon(socialKey: string): string {
  return SOCIAL_ICON_MAPPING[socialKey]
}

const UNLOCK_ICON = 'fa-sharp fa-regular fa-unlock-keyhole'
const ENVELOPE_ICON = 'fa-sharp fa-regular fa-envelope'
const CHECK_CIRCLE_ICON = 'far fa-check-circle'
const WARNING_ICON = 'far fa-brake-warning'

const FA_ICON_MAPPING: ConstantMapping = {
  [UNLOCK]: UNLOCK_ICON,
  [ENVELOPE]: ENVELOPE_ICON,
  [CHECK_CIRCLE]: CHECK_CIRCLE_ICON,
  [WARNING]: WARNING_ICON
}
export function formatFAIcon(Key: string): string {
  return FA_ICON_MAPPING[Key]
}

type ConstantMapping = {
  [key: string]: string
}
